var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_96",
    "data-name": "Group 96",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 96.784,
    height: 50.694,
    viewBox: "0 0 96.784 50.694",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_83",
    "data-name": "Rectangle 83",
    width: 96.784,
    height: 50.694,
    fill: "none",
    stroke: "#0182f0",
    strokeWidth: 1.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_58",
    "data-name": "Group 58",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_279",
    "data-name": "Path 279",
    d: "M44.013,18.01a8.959,8.959,0,1,1-8.957-9.073A9.016,9.016,0,0,1,44.013,18.01Z",
    transform: "translate(13.368 4.577)",
    fill: "rgba(243,235,25,0.4)",
    stroke: "#0182f0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    "data-name": "Path 280",
    d: "M17.04,37.953c0-7.222,10.156-13.078,22.684-13.078S62.407,30.73,62.407,37.953",
    transform: "translate(8.729 12.741)",
    fill: "none",
    stroke: "#0182f0",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_281",
    "data-name": "Path 281",
    d: "M22.173,8.457a7.544,7.544,0,0,1-15.086,0,7.544,7.544,0,0,1,15.086,0Z",
    transform: "translate(3.63 0.511)",
    fill: "rgba(243,235,25,0.4)",
    stroke: "#0182f0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_282",
    "data-name": "Path 282",
    d: "M1,26.364c0-6.309,6.6-11.428,16.648-11.428s16.621,5.119,16.621,11.428",
    transform: "translate(0.512 7.65)",
    fill: "none",
    stroke: "#0182f0",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_283",
    "data-name": "Path 283",
    d: "M62.049,8.557a7.512,7.512,0,1,1-7.511-7.533A7.521,7.521,0,0,1,62.049,8.557Z",
    transform: "translate(24.088 0.524)",
    fill: "rgba(243,235,25,0.4)",
    stroke: "#0182f0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_284",
    "data-name": "Path 284",
    d: "M41,26.4c0-6.362,6.6-11.522,16.647-11.522S74.269,20.034,74.269,26.4",
    transform: "translate(21.002 7.618)",
    fill: "none",
    stroke: "#0182f0",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersIcon);
export default __webpack_public_path__ + "static/media/users-icon.c934b734b3cc9edae6d091b87bffeb39.svg";
export { ForwardRef as ReactComponent };